/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import { ErrorMessage } from "formik";
import {
  TextInputComponent,
  SelectInputComponent,
  RevenueInputComponent,
  CountryCodeWithPhoneNumber,
} from "../../../../../common/components";
import leadInfoIcon from "../../../../../assets/icons/leadInfo.svg";
import OwnerIcon from "../../../../../assets/icons/owner.svg";
import "./create-customer-additional-details.scss";
import { PREFERRED_CONTACT_MODE_OPTIONS } from "../create-customer-helper";

const CreateCustomerAdditionalDetails = (props: any) => {
  return (
    <div className="">
      <div className="customer-create-tab-data-section-line-two-ele">
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
          <div className="form-group">
            <CountryCodeWithPhoneNumber
              fieldName="secondaryPhoneNumber"
              label="Secondary Phone Number"
              placeholder={
                props?.values?.secondaryPhoneNumber
                  ? ""
                  : "Enter Secondary Phone Number"
              }
              onChange={(value: string, country: any, one: any, two: any) => {
                const countryCode = country?.dialCode;

                if (!countryCode) {
                  console.warn("Missing dialCode in country object");
                  return;
                }
                if (`+${countryCode}` == two) {
                  props?.setFieldValue("secondaryPhoneNumber", null);
                } else {
                  if (two?.includes(`+${countryCode}`)) {
                    props?.setFieldValue("secondaryPhoneNumber", two);
                  } else {
                    props?.setFieldValue("secondaryPhoneNumber", countryCode);
                  }
                }
              }}
              onBlur={() => {
                props?.setFieldTouched("secondaryPhoneNumber", true);
              }}
              onKeyDown={(value: any) => {
                if (value.location == 0 && value.key == "Backspace") {
                  props?.setFieldValue(
                    "secondaryPhoneNumber",
                    props?.values?.secondaryPhoneNumber?.substring(
                      0,
                      props?.values?.secondaryPhoneNumber?.length
                    )
                  );
                }
                if (value.location == 0 && value.key == "Delete") {
                  props?.setFieldValue(
                    "secondaryPhoneNumber",
                    props?.values?.secondaryPhoneNumber?.substring(
                      0,
                      props?.values?.secondaryPhoneNumber?.length
                    )
                  );
                }
              }}
              value={props?.values?.secondaryPhoneNumber || "+1"}
              defaultCountry="us"
              optional={true}
              // countryCodeEditable
            />{" "}
            {props?.touched?.secondaryPhoneNumber &&
              props?.touched?.secondaryPhoneNumber && (
                <ErrorMessage
                  name={"secondaryPhoneNumber"}
                  component="div"
                  className="error-message"
                />
              )}
          </div>
        </div>
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="email"
            fieldName="secondaryEmail"
            label="Secondary Email"
            placeholder="Enter Secondary Email"
            optional={false}
            disabled={false}
            value={props?.values.secondaryEmail}
            onChange={(e: any) =>
              props?.setFieldValue("secondaryEmail", e?.target?.value)
            }
          />
        </div>
      </div>
      <div className="customer-create-tab-data-section-line-two-ele">
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            fieldName="company"
            label="Company"
            placeholder="Enter Company"
            optional={false}
            disabled={false}
            value={props?.values.company}
            onChange={(e: any) =>
              props?.setFieldValue("company", e?.target?.value)
            }
            maxlength="50"
          />
        </div>
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
          <div className="form-group">
            <CountryCodeWithPhoneNumber
              fieldName="fax"
              label="Fax"
              placeholder={props?.values?.fax ? "" : "Enter Fax Number"}
              onChange={(value: string, country: any, one: any, two: any) => {
                const countryCode = country?.dialCode;

                if (!countryCode) {
                  console.warn("Missing dialCode in country object");
                  return;
                }
                if (`+${countryCode}` == two) {
                  props?.setFieldValue("fax", null);
                } else {
                  if (two?.includes(`+${countryCode}`)) {
                    props?.setFieldValue("fax", two);
                  } else {
                    props?.setFieldValue("fax", countryCode);
                  }
                }
              }}
              onKeyDown={(value: any) => {
                if (value.location == 0 && value.key == "Backspace") {
                  props?.setFieldValue(
                    "fax",
                    props?.values?.fax?.substring(0, props?.values?.fax?.length)
                  );
                }
                if (value.location == 0 && value.key == "Delete") {
                  props?.setFieldValue(
                    "fax",
                    props?.values?.fax?.substring(0, props?.values?.fax?.length)
                  );
                }
              }}
              onBlur={() => {
                props?.setFieldTouched("fax", true);
              }}
              value={props?.values?.fax || "+1"}
              defaultCountry="us"
              optional={true}
              // countryCodeEditable
            />{" "}
            {props?.touched?.fax && props?.touched?.fax && (
              <ErrorMessage
                name={"fax"}
                component="div"
                className="error-message"
              />
            )}
          </div>
        </div>
      </div>
      <div className="customer-create-tab-data-section-line-two-ele">
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
          <TextInputComponent
            type="text"
            label="Assistant"
            fieldName="assistant"
            value={props?.values.assistant}
            placeholder="Enter Assistant"
            optional={false}
            disabled={false}
            onChange={(e: any) =>
              props?.setFieldValue("assistant", e?.target?.value)
            }
            maxlength="50"
          />
        </div>
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
        <div className="form-group">
            <CountryCodeWithPhoneNumber
              fieldName="assistantPhoneNumber"
              label="Assistant Phone Number"
              placeholder={props?.values?.assistantPhoneNumber ? "" : "Enter assistant phone number"}
              onChange={(value: string, country: any, one: any, two: any) => {
                const countryCode = country?.dialCode;

                if (!countryCode) {
                  console.warn("Missing dialCode in country object");
                  return;
                }
                if (`+${countryCode}` == two) {
                  props?.setFieldValue("assistantPhoneNumber", null);
                } else {
                  if (two?.includes(`+${countryCode}`)) {
                    props?.setFieldValue("assistantPhoneNumber", two);
                  } else {
                    props?.setFieldValue("assistantPhoneNumber", countryCode);
                  }
                }
              }}
              onKeyDown={(value: any) => {
                if (value.location == 0 && value.key == "Backspace") {
                  props?.setFieldValue(
                    "assistantPhoneNumber",
                    props?.values?.assistantPhoneNumber?.substring(0, props?.values?.assistantPhoneNumber?.length)
                  );
                }
                if (value.location == 0 && value.key == "Delete") {
                  props?.setFieldValue(
                    "assistantPhoneNumber",
                    props?.values?.assistantPhoneNumber?.substring(0, props?.values?.assistantPhoneNumber?.length)
                  );
                }
              }}
              onBlur={() => {
                props?.setFieldTouched("assistantPhoneNumber", true);
              }}
              value={props?.values?.assistantPhoneNumber || "+1"}
              defaultCountry="us"
              optional={true}
            />{" "}
            {props?.touched?.assistantPhoneNumber && props?.touched?.assistantPhoneNumber && (
              <ErrorMessage
                name={"assistantPhoneNumber"}
                component="div"
                className="error-message"
              />
            )}
          </div>
        </div>
      </div>
      <div className="customer-create-tab-data-section-line-two-ele">
        <div className="customer-create-tab-data-section-line-two-ele-side-one">
          <SelectInputComponent
            fieldName="preferredContactMode"
            label="Preferred Contact Mode"
            options={PREFERRED_CONTACT_MODE_OPTIONS}
            onChange={props?.setPreferredContactMode}
            value={props?.preferredContactMode}
            placeholder="Select Preferred Contact Mode"
          />
        </div>
      </div>
    </div>
  );
};

export default CreateCustomerAdditionalDetails;
